import { useStytchMember } from '@stytch/react/b2b'

/**
 * The signed-in user's Pixydocs user id — `external_id` is the pd id behind a
 * Stytch member, and the id every API reports users by (approvers, assignees,
 * activity logs). Undefined for a member who was invited but has never logged
 * in, since there's no pd user yet.
 */
export default function useViewerId(): string | undefined {
  const { member } = useStytchMember()
  return member?.external_id ?? undefined
}
